import React, { createContext, useContext, useState, useEffect } from 'react';

const THEMES = {
  forest: {
    id: 'forest', label: 'Forest', icon: '🌿',
    bgPrimary: '#F4F7F2', bgSecondary: '#EBF0E8', bgCard: '#FFFFFF', bgCardHover: '#F0F5ED',
    bgSidebar: '#EFF4EC', bgHero: 'linear-gradient(170deg, #F4F7F2, #E4EDE0, #F0F5ED)',
    textPrimary: '#1E2B1A', textSecondary: '#4A5E42', textMuted: '#7B9470', textDim: '#AABFA2',
    border: '#D5E3CF', borderHover: '#BFD4B6',
    accentGreen: '#4A8C3F', accentGreenLight: '#DFF0DA', accentGreenHover: '#3A7A30',
    accentGold: '#B58B2E', accentGoldLight: '#FBF3DD',
    accentPurple: '#6E5E7A', accentPurpleLight: '#EDE8F0',
    accentRose: '#9E6B75', accentRoseLight: '#F5ECEe',
    male: '#4A8C3F', female: '#9E6B75', memorial: '#6E5E7A',
    btnGradient: 'linear-gradient(135deg, #4A8C3F, #6BAF5E)',
    btnShadow: 'rgba(74,140,63,0.2)',
    nodeWhite: '#FFFFFF',
  },
  sunset: {
    id: 'sunset', label: 'Sunset', icon: '🌅',
    bgPrimary: '#FEF7F0', bgSecondary: '#FAEDE0', bgCard: '#FFFFFF', bgCardHover: '#FDF2E8',
    bgSidebar: '#FBF0E5', bgHero: 'linear-gradient(170deg, #FEF7F0, #F9E8D5, #FDE9D0)',
    textPrimary: '#3D2814', textSecondary: '#6B4D35', textMuted: '#A08068', textDim: '#CCAF98',
    border: '#EEDCCC', borderHover: '#E0C8B2',
    accentGreen: '#7A9A4A', accentGreenLight: '#EEF4E0',
    accentGreenHover: '#6A8A3A',
    accentGold: '#D4882A', accentGoldLight: '#FDF0DA',
    accentPurple: '#8E6B5A', accentPurpleLight: '#F2E8E4',
    accentRose: '#C86E5A', accentRoseLight: '#FAEAE6',
    male: '#7A9A4A', female: '#C86E5A', memorial: '#8E6B5A',
    btnGradient: 'linear-gradient(135deg, #D4882A, #E8A54A)',
    btnShadow: 'rgba(212,136,42,0.2)',
    nodeWhite: '#FFFFFF',
  },
  ocean: {
    id: 'ocean', label: 'Ocean', icon: '🌊',
    bgPrimary: '#F0F5F8', bgSecondary: '#E4EDF3', bgCard: '#FFFFFF', bgCardHover: '#EBF2F7',
    bgSidebar: '#E8F0F5', bgHero: 'linear-gradient(170deg, #F0F5F8, #DCE8F0, #E2EEF6)',
    textPrimary: '#1A2B3A', textSecondary: '#3E5568', textMuted: '#6B8A9E', textDim: '#9DBACE',
    border: '#CBDCE8', borderHover: '#B0CCDC',
    accentGreen: '#3E8E7A', accentGreenLight: '#DEF0EC',
    accentGreenHover: '#2E7E6A',
    accentGold: '#B8933A', accentGoldLight: '#F8F0DC',
    accentPurple: '#5A6E8E', accentPurpleLight: '#E4EAF2',
    accentRose: '#8E6070', accentRoseLight: '#F0E6EA',
    male: '#3E8E7A', female: '#8E6070', memorial: '#5A6E8E',
    btnGradient: 'linear-gradient(135deg, #3E8E7A, #58B0A0)',
    btnShadow: 'rgba(62,142,122,0.2)',
    nodeWhite: '#FFFFFF',
  },
  midnight: {
    id: 'midnight', label: 'Midnight', icon: '🌙',
    bgPrimary: '#12151C', bgSecondary: '#1A1E28', bgCard: '#1E2230', bgCardHover: '#252A38',
    bgSidebar: '#161A24', bgHero: 'linear-gradient(170deg, #12151C, #1A1E28, #141820)',
    textPrimary: '#E8E4F0', textSecondary: '#A0A0B8', textMuted: '#686880', textDim: '#42425A',
    border: '#2A2E3E', borderHover: '#3A3E50',
    accentGreen: '#6EAA8E', accentGreenLight: '#1A2A24',
    accentGreenHover: '#5E9A7E',
    accentGold: '#D4AF7F', accentGoldLight: '#2A2418',
    accentPurple: '#A88EC0', accentPurpleLight: '#221E2C',
    accentRose: '#D08898', accentRoseLight: '#2A1E22',
    male: '#6EAA8E', female: '#D08898', memorial: '#A88EC0',
    btnGradient: 'linear-gradient(135deg, #6EAA8E, #88C4A8)',
    btnShadow: 'rgba(110,170,142,0.2)',
    nodeWhite: '#E8E4F0',
  },
  parchment: {
    id: 'parchment', label: 'Parchment', icon: '📜',
    bgPrimary: '#F5EFE4', bgSecondary: '#ECE4D5', bgCard: '#FAF6EE', bgCardHover: '#F0EAD8',
    bgSidebar: '#EFE8DA', bgHero: 'linear-gradient(170deg, #F5EFE4, #E8DEC8, #EDE4D0)',
    textPrimary: '#3A3020', textSecondary: '#635840', textMuted: '#957E60', textDim: '#BCA888',
    border: '#DDD2BE', borderHover: '#CCBFA5',
    accentGreen: '#6E8E4A', accentGreenLight: '#E6EED8',
    accentGreenHover: '#5E7E3A',
    accentGold: '#B08030', accentGoldLight: '#F5EAD2',
    accentPurple: '#7A6A5A', accentPurpleLight: '#EDE6DC',
    accentRose: '#A06858', accentRoseLight: '#F2E6E0',
    male: '#6E8E4A', female: '#A06858', memorial: '#7A6A5A',
    btnGradient: 'linear-gradient(135deg, #6E8E4A, #8EAE6A)',
    btnShadow: 'rgba(110,142,74,0.2)',
    nodeWhite: '#FAF6EE',
  },
};

const ThemeContext = createContext(null);

export const useTheme = () => {
  const ctx = useContext(ThemeContext);
  if (!ctx) throw new Error('useTheme must be used within ThemeProvider');
  return ctx;
};

export const ThemeProvider = ({ children }) => {
  const [themeId, setThemeId] = useState(() => {
    try { return localStorage.getItem('vanshatree_theme') || 'forest'; }
    catch { return 'forest'; }
  });

  const theme = THEMES[themeId] || THEMES.forest;

  useEffect(() => {
    try { localStorage.setItem('vanshatree_theme', themeId); } catch {}
    const r = document.documentElement;
    Object.entries({
      '--bg-primary': theme.bgPrimary, '--bg-secondary': theme.bgSecondary,
      '--bg-card': theme.bgCard, '--bg-card-hover': theme.bgCardHover,
      '--bg-sidebar': theme.bgSidebar,
      '--text-primary': theme.textPrimary, '--text-secondary': theme.textSecondary,
      '--text-muted': theme.textMuted, '--text-dim': theme.textDim,
      '--border': theme.border, '--border-hover': theme.borderHover,
      '--accent-green': theme.accentGreen, '--accent-green-light': theme.accentGreenLight,
      '--accent-gold': theme.accentGold, '--accent-gold-light': theme.accentGoldLight,
      '--accent-purple': theme.accentPurple, '--accent-purple-light': theme.accentPurpleLight,
      '--accent-rose': theme.accentRose, '--accent-rose-light': theme.accentRoseLight,
    }).forEach(([k, v]) => r.style.setProperty(k, v));
    document.body.style.background = theme.bgPrimary;
    document.body.style.color = theme.textPrimary;
  }, [themeId, theme]);

  const setTheme = (id) => { if (THEMES[id]) setThemeId(id); };
  const cycleTheme = () => {
    const ids = Object.keys(THEMES);
    setThemeId(ids[(ids.indexOf(themeId) + 1) % ids.length]);
  };

  return (
    <ThemeContext.Provider value={{ theme, themeId, setTheme, cycleTheme, themes: THEMES }}>
      {children}
    </ThemeContext.Provider>
  );
};
